import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { requirePermission } from '@/app/guards';
import { OrganizationPage } from '@/features/admin';

export const Route = createFileRoute('/_app/admin/organization')({
  validateSearch: z.object({ asAt: z.iso.date().optional().catch(undefined) }),
  staticData: { crumb: 'admin:nav.organization' },
  beforeLoad: ({ context }) => requirePermission(context.queryClient, 'admin.users', 'Setup'),
  component: function Organization() {
    const { asAt } = Route.useSearch();
    const navigate = Route.useNavigate();
    return <OrganizationPage asAt={asAt} onAsAtChange={(v) => void navigate({ search: { asAt: v }, replace: true })} />;
  },
});
